import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import { useNavigate } from 'react-router-dom'
import ProjectTypesTable from './components/ProjectTypesTable'
import { useProjectStagesState } from './hooks/useProjectStagesState'
import { useAllCheckpointsState } from '../ProjectCheckpoints/hooks/useAllCheckpointsState'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'

const ProjectTypesPage = () => {
  const navigate = useNavigate()

  const { loading: loadingProjectStages } = useProjectStagesState()
  const { loading: loadingCheckpoints } = useAllCheckpointsState()

  if (loadingCheckpoints || loadingProjectStages) {
    return (
      <AdminNavigationLayout>
        <TopNavigationLayoutPageContent type='default'>
          <div className='flex-page-center'>
            <ThreeDotsLoader />
          </div>
        </TopNavigationLayoutPageContent>
      </AdminNavigationLayout>
    )
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Типы проекта</h2>
          </div>
          <div className='inline-flex-gap'>
            <Button theme='primary' onClick={() => navigate('/admin/project-types/create')}>
              <span className='inline-flex-gap' style={{ gap: '0.5em' }}>
                <span>+</span>
                <span>Создать</span>
              </span>
            </Button>
          </div>
        </div>
        <ProjectTypesTable />
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default ProjectTypesPage
